module.exports = __webpack_public_path__ + "static/media/horizontal-rule.4f12853d.svg";